import { Routes } from "@shuttlerock/router";
import { matchPath } from "react-router";

const AUTH_ROUTES = [Routes.Auth.SignIn, Routes.Auth.SignOut, Routes.Auth.Callback] as const;

const CLIENT_ACCOUNT_BOOTSTRAP_EXEMPT_ROUTES = [Routes.Auth.AcceptInvite] as const;

const matchesRoute = (pathname: string, route: string): boolean =>
  matchPath({ path: route, end: true }, pathname) != null;

export const isAuthRoute = (pathname: string): boolean =>
  AUTH_ROUTES.some((route) => matchesRoute(pathname, route));

export const shouldSkipClientAccountBootstrap = (pathname: string): boolean =>
  CLIENT_ACCOUNT_BOOTSTRAP_EXEMPT_ROUTES.some((route) => matchesRoute(pathname, route));
